import { ChangeDetectorRef, Component, Input, OnInit, EventEmitter, Output } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { HomeService } from "../home.services";
import * as FileSaver from "file-saver";
import { CompetitiveIntelligenceService } from "./competitive-intelligence.service";
import { environment } from "src/environments/environment.prod";
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

@Component({
  selector: "app-competitive-intelligence",
  templateUrl: "./competitive-intelligence.component.html",
  styleUrls: ["./competitive-intelligence.component.scss"],
})
export class CompetitiveIntelligenceComponent implements OnInit {
  @Input() MolData: any;
  @Input() ActiveIngred: any;
  @Input() BrandName: any;
  @Input() NDAnumber: any;
  @Input() saveOldData: any;
  @Output() CompetitiveHeaderUpdated = new EventEmitter<string>();
  Molecule: boolean;
  secondSectionData: any;
  DragData: any = {};
  typeArray = ["paraI", "paraII", "paraIII", "paraIV"];
  contentTableArray = [];
  popupcontents: any;
  contentPopups = "none";
  content_Details: [];
  content_value: "";
  sliceEnd = 5;
  contentKey = "";
  displaypopup = "none";
  data: [][];
  refEditData = {};
  submolecules: any[];
  subMolecule = false;
  selectedSubMolecule: any;
  searchValue = "";
  noData = false;
  showedit = false;
  tempData: any = {};
  changed_Cols: [];
  tablekeys: string[];
  tableData: any = [];
  tablevalues: any = [];
  colorcode: {};
  objectKeys = Object.keys;
  objectValues = Object.values;
  linkURL: any;
  paramsValues: any;
  editedData: any;
  storedData: any;
  keysArray: Array<String> = [];
  keyIds: Array<String> = [];
  showCheckBox = false;
  options: any = [];
  FiledANDA: any;
  uniqNumber: any;
  UserIp: any;
  email: any;
  ShowLmsMessage: any;
  fieldInformation: any;
  displayReviewDialog: boolean = false;
  selectedKey: string = '';
  selectedEmail: any;
  reviewComment: string = '';
  emailList: any[] = [];
  drugName: any;
  drugActiveIngredient: any;
  drugNdaNumber: any;
  drugDosageForm: any;
  submitted: boolean = false; // Track form submission
  verificationMessage: string = '';
  public Editor = ClassicEditor;
  public editorData = '<p>Type your content here...</p>';

  brandDetailsTableData: any[] = [];
  isBrandDetailsLoading: boolean = false;
  isForeignCurrency = false;
  currencyTypeText = '';

  constructor(
    private compitiveService: CompetitiveIntelligenceService,
    private ref: ChangeDetectorRef,
    public toastr: ToastrService,
    private route: ActivatedRoute,
    private homeservice: HomeService,
    private sanitized: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.uniqNumber = this.route.snapshot.queryParams["uniqnumber"];
    this.UserIp = localStorage.getItem("ipaddress");
    this.email = localStorage.getItem("email");
    this.fetchEmails();
    this.paramsValues = this.route.snapshot.queryParams;
    if (
      this.paramsValues.active_ingredient &&
      this.paramsValues.brand_name &&
      this.paramsValues.ndaValue &&
      this.paramsValues.section
    ) {
      this.getEditedChanges(
        this.paramsValues.active_ingredient,
        this.paramsValues.brand_name,
        this.paramsValues.ndaValue,
        this.UserIp,
        this.uniqNumber,
        this.email
      );
      this.Molecule = true;
    } else {
      this.getCompititiveInfo();
    }
  }

  getCompititiveInfo() {
    let active_ingredient = this.ActiveIngred;
    let brand_name = this.BrandName;
    let ndaValue = this.NDAnumber;
    let sectionSeven = "competitive_intelligence_details";
    const base64Encode = (str: string): string => {
      return btoa(unescape(encodeURIComponent(str)))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
    };

    const encodedActiveIngredient = base64Encode(active_ingredient);
    const encodedBrandName = base64Encode(brand_name);
    this.linkURL = `${environment.ip}/#/home?active_ingredient=${encodedActiveIngredient}&brand_name=${encodedBrandName}&ndaValue=${ndaValue}&section=${sectionSeven}`;
    // this.linkURL = `http://3.111.249.237/#/home?active_ingredient=${active_ingredient}&brand_name=${brand_name}&ndaValue=${ndaValue}&section=${sectionSeven}`;
    this.compitiveService
      .getSeventhSection(ndaValue, brand_name)
      .subscribe((competitive: any) => {
        this.Molecule = true;
        this.ShowLmsMessage = competitive?.['status_message']
        this.colorcode =
          competitive.data["COMPETITIVE INTELLIGENCE"]["colorindicator"];
        this.fieldInformation = competitive.data["COMPETITIVE INTELLIGENCE"]["field_information"];
        console.log("fieldInformation", this.fieldInformation)
        this.checkFieldVerificationStatus();

        setTimeout(() => {
          // Emit the updated header with verification status
          const updatedHeader = this.verificationMessage; // Updated message
          console.log("Emitting:", updatedHeader); // Debugging the emission
          this.CompetitiveHeaderUpdated.emit(updatedHeader);  // Emit updated header value to parent
        }, 1000);
        let obj = competitive.data["COMPETITIVE INTELLIGENCE"];

        // Make a new object
        let reordered: any = {};
        for (let key of Object.keys(obj)) {
          reordered[key] = obj[key];

          if (key === "Reported volume") {
            // insert Peak Sale Insights immediately after
            reordered["Peak Sale Insights"] = obj["Peak Sale Insights"];
          }
        }

        // Assign reordered object to your variable
        this.DragData = reordered;

        let filedAndAData = this.DragData["Filed ANDA"];
        // console.log("filed", filedAndAData)
        // if (filedAndAData !== "N/A") {
        //   console.log("if")
        //   filedAndAData = filedAndAData.filter(
        //     (item) => Array.isArray(item) && item.length > 0
        //   );
        //   console.log("filed in if", filedAndAData)
        //   // Remove empty objects
        //   filedAndAData = filedAndAData.filter(
        //     (item) => typeof item === "object" && Object.keys(item).length > 0
        //   );
        // }

        // Update the original data
        this.DragData["Filed ANDA"] = filedAndAData;
        console.log(this.DragData["Filed ANDA"]);
        this.tempData = competitive.data["COMPETITIVE INTELLIGENCE"];
        this.refEditData = competitive.data["COMPETITIVE INTELLIGENCE"];

        this.getBrandDetailsTable();
      });
  }

  checkFieldVerificationStatus() {
    // Start with the default message
    let verificationMessage = 'COMPETITIVE INTELLIGENCE';

    // Iterate over each section (key) in fieldInformation
    for (const section in this.fieldInformation) {
      if (this.fieldInformation.hasOwnProperty(section)) {
        // Check if any item in the current section has field_verified as false
        const unverifiedField = this.fieldInformation[section].some(item => item.field_verified === false || item.field_verified === "N/A");

        if (unverifiedField) {
          // Add HTML span for highlighting the pending verification part
          verificationMessage += " - Verification of field is pending";
          break; // Stop after the first match (you can continue checking all sections if needed by removing this line)
        }
      }
    }

    // Store the final message (HTML)
    this.verificationMessage = verificationMessage;

    // Optionally, log the verification message
    console.log(this.verificationMessage);
  }

  showArray(data, n2, n3, n4, n5, n6, n7) {
    this.contentPopups = "block";
    this.contentTableArray = data;
  }
  Selectparam(event) {
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = this.saveOldData//JSON.parse(referdata);
    let brand_name: any;
    brand_name = moleculedata["Brand Name/Proprietary Name"];
    let obj = {
      type: event.target.value,
      brand_name: moleculedata["Brand Name/Proprietary Name"],
    };
    this.homeservice.addPara(obj).subscribe((res) => { });
  }

  showLess(data, n2, n3, n4, n5, n6, n7) {
    this.contentPopups = "block";
    this.tablekeys = Object.keys(data[0]);
    this.tablevalues = data;
  }

  /**
   *
   * @param InputProperty  value entered
   * @param Objectvalue     object values of the keys in an object
   * @returns
   */
  getcolorcode(InputProperty: string, Objectvalue: any): any {
    if (Objectvalue[InputProperty] !== undefined) {
      return Objectvalue[InputProperty];
    } else {
      return "";
    }
  }
  /**
   * Method to handle search
   */

  getEditedValues() {
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = this.saveOldData//JSON.parse(referdata);
    let active_ingredient = moleculedata["Active Ingredient"];
    let brand_name = moleculedata["Brand Name/Proprietary Name"];
    let ndaNumber = moleculedata["NDA number"];
    this.getEditedChanges(
      active_ingredient,
      brand_name,
      ndaNumber,
      this.UserIp,
      this.uniqNumber,
      this.email
    );
  }

  getEditedChanges(
    active_ingredient: string,
    brand_name: string,
    ndaNumber: number,
    userIp: string,
    uniqnumber: number,
    email: string
  ) {
    this.compitiveService
      .getEditedData(
        active_ingredient,
        brand_name,
        ndaNumber,
        userIp,
        uniqnumber,
        email
      )
      .subscribe((res: any) => {
        if (this.paramsValues.section === "competitive_intelligence_details") {
          this.DragData = res.previously_updated_db_data;
          this.storedData = res.data.edited_data_key_insert_to_db;
        }
      });
  }

  isChanged(key): any {
    this.keysArray = [];
    if (this.storedData) {
      Object.keys(this.storedData).map((keys) => {
        if (keys === key) {
          this.keysArray.push(keys);
        }
      });
      return this.keysArray;
    }
  }

  editbtn() {
    this.showedit = !this.showedit;
    if (this.showedit === true) {
      this.sliceEnd = 1000;
    } else {
      this.sliceEnd = 5;
    }
  }

  downloadFiles() {
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = this.saveOldData//JSON.parse(referdata);
    this.homeservice
      .getdownloadfile({
        nda_number: moleculedata["NDA number"],
        brand_name: moleculedata["Brand Name/Proprietary Name"],
      })
      .subscribe((res) => {
        let resp = res["data"]["content"];
        let file = res["data"]["filename"];
        FileSaver.saveAs(
          `data:application/vnd.ms-excel;base64,${resp}`,
          `${file}`
        );
      });
  }

  // Hide and show checboxes
  downloadSelected() {
    this.showCheckBox = !this.showCheckBox;
  }
  // Selecting the checkbox
  selected_checbox(event: any, index: number) {
    if (!this.options.includes(event)) {
      this.options = [...this.options, event];
    } else {
      this.options = this.options.filter((item) => item !== event);
    }
  }
  // Download based on selected items
  downloadSelectedData() {
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = this.saveOldData//JSON.parse(referdata);
    let columns_data = this.options;
    this.homeservice
      .downloadSelected({
        nda_number: moleculedata["NDA number"],
        brand_name: moleculedata["Brand Name/Proprietary Name"],
        columns_data,
      })
      .subscribe((res) => {
        let resp = res["data"]["content"];
        let file = res["data"]["filename"];
        FileSaver.saveAs(
          `data:application/vnd.ms-excel;base64,${resp}`,
          `${file}`
        );
      });
  }

  closecontentpopup() {
    // if (event === 'cancel') {

    this.content_Details = [];
    this.tableData = [];
    this.tablekeys = [];
    this.content_value = "";
    this.contentKey = "";
    this.contentPopups = "none";
    this.contentTableArray = [];
    // }
  }

  addClickEvent(event, value, key) {
    if (
      key === "Dosage and Administration" ||
      key === "Recommended dose" ||
      key === "Indications and Usage"
    ) {
      this.contentPopups = "block";
      this.content_Details = value;
      this.contentKey = key;
      this.content_value = "";
    } else if (
      key === "Variability (% ISCV)" ||
      key === "PK Linearity" ||
      key === "Food effect" ||
      key === "Pharmacology"
    ) {
      this.contentPopups = "block";
      this.content_Details = [];
      this.contentKey = key;
      this.content_value = value;
    } else {
      this.contentPopups = "none";
      this.content_Details = [];
      this.contentKey = "";
      this.content_value = "";
    }
    // if(event.type === 'mouseleave'){
    //   this.contentPopups = 'none';
    //   this.content_Details = [];
    //   this.contentKey ='';
    //   this.content_value ='';
    // }
  }



  addTable(data, n4, n5, n6, n7) {
    let objdata: any = this.DragData;
    console.log("this.objdata before", n7);

    if (Array.isArray(objdata[n7])) {
      objdata[n7] = [];
    } else if (typeof objdata[n7] === 'string') {
      objdata[n7] = [];
    } else {
      objdata[n7] = [];
    }

    // let newRow = { "Header 1": "Cell 1", "Header 2": "Cell 2" };

    let headers;
    switch (n7) {
      case 'Approved ANDA filers':
        headers = ["ANDA No", "Drug Name", "Active Ingredients", "Strength", "Dosage Form/Route", "Marketing Status",
          "Approval Date", "Applicant Holder", "TE Code", "RLD", "RS"];
        break;
      case 'Tentatively approved ANDAs':
        headers = ["ANDA No", "Drug Name", "Active Ingredients", "Strength", "Dosage Form/Route", "Marketing Status",
          "Tentative Approval Date", "Approval Holder"];
        break;
      case 'No of shared FTFs':
        headers = ["NDA #", "Brand Name", "DOSAGE FORM", "STRENGTH", "DATE OF SUBMISSION",
          "NUMBER OF ANDAs SUBMITTED", "180-DAY STATUS"];
        break;
      case 'Innovator / RLD Price ($/pack)':
        headers = ["Quantity", "Per unit", "Price", "Strengths", "Roa", "Description"];
        break;
      case 'Competing products':
        headers = ["ATC code", "Name"];
        break;
      case 'Reported sales':
        headers = ["YTD Oct 2017_Sales $", "YTD Oct 2018_Sales $", "YTD Oct 2019_Sales $", "YTD Oct 2020_Sales $",
          "YTD Oct 2021_Sales $"];
        break;
      case 'Reported volume':
        headers = ["YTD Oct 2017_NSP Ext Units", "YTD Oct 2018_NSP Ext Units", "YTD Oct 2019_NSP Ext Units",
          "YTD Oct 2020_NSP Ext Units", "YTD Oct 2021_NSP Ext Units"];
        break;
      default:
        headers = ["Default Header 1", "Default Header 2"];
        break;
    }

    // Create a new row based on the defined headers
    let newRow = {};
    headers.forEach(header => {
      newRow[header] = "Cell " + (Object.keys(newRow).length + 1);
    });
    objdata[n7].push(newRow);

    this.DragData = { ...objdata };
    console.log("this.DragData after", this.DragData);
    this.tempData = { ...objdata };
  }

  deleteTable(key: string) {
    let objdata: any = this.DragData;

    if (objdata.hasOwnProperty(key)) {
      objdata[key] = "N/A";
    }

    this.DragData = { ...objdata };
    this.tempData = { ...objdata };

    console.log("Table deleted for key:", key);
  }

  addItems(data, n2, n3, n4, n5, n6, n7) {
    debugger;
    let objdata: any = this.DragData;
    let obj = {};
    let arr = [];
    let keys = Object.keys(data[0]);
    for (let i = 0; i <= keys.length - 1; i++) {
      obj[keys[i]] = "";
    }
    objdata[n7].push(obj);
    this.DragData = { ...objdata };
    this.ref.markForCheck();
  }

  addListItem(data, n4, n5, n6, n7) {
    if (
      n7 === "Reference Standard (RS)" &&
      Array.isArray(this.DragData[n7]) &&
      this.DragData[n7].length === 0
    ) {
      // If "Filed ANDA" is an empty array, push an empty array to it
      this.DragData[n7].push([]);
    } else {
      let objdata: any = this.DragData;
      if (typeof objdata[n7] === 'string') {
        objdata[n7] = [objdata[n7]];
      }
      let arr = [];
      console.log("Arrayyyy", objdata[n7].push(arr));
      this.DragData = { ...objdata };
      this.tempData = { ...objdata };
    }
  }

  deleteListItem(value: any, key: any, index: number) {
    console.log("deleteItemmm", value, index);
    let objdata: any = this.DragData;
    if (value.length > 1) {
      value.splice(index, 1);

      const keysToConvert = ['Approved ANDA filers', 'Tentatively approved ANDAs', 'Drug in Shortage currently?', 'Indicative API price ($/kg)',
        'Additional comments on Competitive Intelligence', '180 Day Exclusivity', 'Current Market Shares(%)',
        'Probable API source?', 'Comment (if any)'];

      // Convert back to string if only one item left
      if (value.length === 1 && keysToConvert.includes(key)) {
        if (this.DragData[key]) {
          this.DragData[key] = value[0];
        }
      }

      this.DragData = { ...objdata };
    }
  }

  deleteRow(Obj: any, index: number) {
    let objdata: any = this.DragData;
    if (Obj.length > 1 && index > -1) {
      Obj.splice(index, 1);
      console.log("deleteRow", Obj, index);
      this.DragData = { ...objdata };
    }
  }

  replaceWithNA(value: any, key: any) {
    let objdata: any = this.DragData;

    objdata[key] = 'N/A';

    this.DragData = { ...objdata };
    this.tempData = { ...objdata };
  }


  //** We can edit the data based on object,array and array of objects */
  editdata(event, arr, keys, trows, rd, Obj, index, varikey, n9, n10) {
    if (Obj !== undefined) {
      if (this.tempData[keys] && Obj.value) {
        this.tempData[keys].map((res, j) => {
          Obj.value.map((resp, j1) => {
            if (j === index && j === j1) {
              let objkey = Object.keys(Obj.value[0]);
              let uniquekey = objkey[n10];
              resp[uniquekey] = event.target ? event.target.value : event;
            }
          });
        });
      }
    }
    if (Obj === "lItems") {
      if (Array.isArray(this.tempData[keys])) {
        this.tempData[keys].map((respp, k) => {
          if (arr) {
            arr.map((resps, p) => {
              if (p === rd) {
                if (resps === trows) {
                  arr[rd] = event.target.value;
                }
              }
            });
          } else {
          }
        });
      }
    } else if (Obj === undefined) {
      this.tempData[keys] = event.target ? event.target.value : event;
      // this.tempData[keys] = event.target.value;
    }
  }

  saveEdit() {
    this.sliceEnd = 5;
    this.showedit = !this.showedit;
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = this.saveOldData//JSON.parse(referdata);
    let editedData: any = {};
    editedData["edited_data"] = this.tempData;
    editedData["nda_number"] = moleculedata["NDA number"];
    if (
      this.DragData["Filed ANDA"] != "N/A" &&
      this.DragData["Filed ANDA"] != ""
    ) {
      let myArray = []; // Initialize an empty array
      let myString = this.DragData["Filed ANDA"];

      for (let i = 0; i < myString.length; i++) {
        const element = myString[i];
        if (!Array.isArray(myString)) {
          myArray.push(element);
        } else {
          editedData["edited_data"]["Filed ANDA"] = myString;
        }
      }

      // console.log(myArray);
      // editedData["edited_data"]["Filed ANDA"] = myArray;
      // let myString = this.DragData["Filed ANDA"]; // String to push into the array
      // myString = myString.filter((subArray) => subArray.length > 0);
      // console.log(myString);
      // if (
      //   this.tempData["Filed ANDA"] != "N/A" &&
      //   this.tempData["Filed ANDA"] != "" &&
      //   !Array.isArray(myString)
      // ) {
      //   myArray.push(myString);
      //   editedData["edited_data"]["Filed ANDA"] = myArray;
      // } else if (myString.includes("N/A") || myString.includes("")) {
      //   editedData["edited_data"]["Filed ANDA"] = myString;
      // } else {
      //   editedData["edited_data"]["Filed ANDA"] = myString;
      // }
    }
    else {
      editedData["edited_data"]["Filed ANDA"] = this.DragData["Filed ANDA"];
    }
    editedData["brand_name_proprietary_name"] =
      moleculedata["Brand Name/Proprietary Name"];
    editedData["active_ingredient"] = moleculedata["Active Ingredient"];
    editedData["link"] = this.linkURL;
    editedData["email"] = this.email;
    this.compitiveService
      .SendEmail(
        editedData["active_ingredient"],
        editedData["brand_name_proprietary_name"],
        editedData["nda_number"],
        editedData["email"],
        editedData
      )
      .subscribe((res: any) => {
        if (res && res.error && res.error === "Pending in LMS. Please take actions first; then editing will be allowed.") {
          this.toastr.error(res.error, "Error", {
            timeOut: 10000,   // Toast duration in milliseconds
            positionClass: 'toast-top-right',  // Position the toast in the top-right corner
            closeButton: true
          });
        }
      });
  }

  handelAction(key, flag, i) {
    let updatedValue = {
      nda_number: this.paramsValues.ndaValue,
      field: key,
      flag,
      brand_name: this.paramsValues.brand_name,
      active_ingredient: this.paramsValues.active_ingredient,
      userip: localStorage.getItem("ipaddress"),
      uniqnumber: this.uniqNumber,
      email: localStorage.getItem("email"),
    };
    this.compitiveService
      .updateMoleculeData(updatedValue)
      .subscribe((res: any) => {
        if (flag === "accept") {
          this.keyIds.push(key.key);
          document.getElementById(key.key).style.display = "none";
          this.toastr.success("Data updated sucessfully", "");
        } else {
          this.DragData = res.old_data_with_updated_set;
          this.keyIds.push(key.key);
          setTimeout(() => {
            this.keyIds.forEach((id: String) => {
              document.getElementById(`${id}`).style.display = "none";
            });
          }, 0);
          this.toastr.error("Data rejected sucessfully", "");
        }
      });
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitized.bypassSecurityTrustHtml(html);
  }

  openPdf(value) {
    let url: any = window.open(`https://oneclickfolio.com/pm_backend/${value}`);
    return this.sanitized.bypassSecurityTrustHtml(url);
  }

  getTooltipContent(key: string): string {
    if (this.fieldInformation && this.fieldInformation[key]) {
      return this.fieldInformation[key]
        .map(
          (item: any) =>
            `Source: ${item.source} <br> 
             LMS No: ${item.lms_unique_no} <br> 
             Approved By: ${item.field_approved_by} <br> 
             Last Update: ${item.last_update_date} <br> 
             Last Verified By: ${item.last_verified_by || "N/A"} <br> 
             Last Reviewed By: ${item.Last_reviewed_by || "N/A"} <br> 
             Last Verified Date: ${item.last_verified_date || "N/A"} <br> 
             Last Reviewed Date: ${item.last_reviewed_date || "N/A"}`
        )
        .join("<br><br>"); // Double <br> for spacing between items
    }
    return "No information available";
  }

  openReviewDialog(key: string) {
    this.selectedKey = key;
    this.displayReviewDialog = true;
  }

  fetchEmails() {
    this.homeservice.getUserMailId(this.email).subscribe(
      (response: any) => {
        console.log("API Response:", response);

        if (response && response.data) {
          this.emailList = response.data.map(item => ({ label: item.email, value: item.email })); // Correct format for p-dropdown
        } else {
          this.emailList = [];
        }

        console.log("Formatted Emails for Dropdown:", this.emailList);
      },
      error => {
        console.error("Error fetching emails:", error);
      }
    );
  }

  isCommentValid(): boolean {
    return this.selectedEmail && this.reviewComment.length >= 15;
  }

  submitReview() {
    this.submitted = true;
    if (!this.selectedEmail || !this.reviewComment || this.reviewComment.length < 15) {
      this.toastr.error("Please enter at least 15 characters in the comment.", "Error");
      return;
    }

    const reviewData = {
      user_mail: this.email,
      reviewer_email: this.selectedEmail,       // Email of the reviewer
      comment: this.reviewComment,     // Review comment (at least 15 chars)
      field: this.selectedKey,         // Field that is being reviewed
      section: "COMPETITIVE INTELLIGENCE",   // Hardcoded section name
      drugBrandName: this.BrandName,         // Brand Name from API response
      drugNdaNumber: this.NDAnumber,   // NDA Number from API response
      // drugDosageForm: this.drugDosageForm  // Dosage Form from API response
    };

    console.log('Submitting:', reviewData);

    this.homeservice.submitFieldReview(reviewData).subscribe(
      (response) => {
        console.log("Review submitted successfully:", response);
        this.toastr.success("Reviewed field successfully", "Success");
        this.reviewComment = '';
        this.selectedEmail = '';
        this.displayReviewDialog = false;
        this.fieldInformation[this.selectedKey][0].field_reviewed = true; // Disable Review button
        this.fieldInformation[this.selectedKey][0].field_verified = false;
      },
      (error) => {
        console.error("Error submitting review:", error);
        this.toastr.error("Failed to submit review. Try again.", "Error");
      }
    );
  }


  verifyField(fieldKey: string) {
    const fieldInfo = this.fieldInformation[fieldKey];

    if (!fieldInfo) {
      this.toastr.error('Field information not found!', 'Error');
      return;
    }

    if (fieldInfo.field_verified) {
      this.toastr.info('Already Verified!', 'Info');
      return;
    }

    const payload = {
      user_mail: this.email,
      field_key: fieldKey,
      nda_number: this.NDAnumber,             // NDA Number from API response
      brand_name: this.BrandName,             // Brand Name from API response
    };

    console.log("Payload for verification:", payload);

    this.homeservice.verifyFieldData(payload).subscribe(
      (response) => {
        // console.log("Review submitted successfully:", response);
        this.toastr.success("Field verified successfully", "Success");
        this.fieldInformation[fieldKey][0].field_verified = true;
        this.fieldInformation[fieldKey][0].field_reviewed = false;

        // this.getpatentInfo();
      },
      (error) => {
        console.error("Failed to verify field", error);
        this.toastr.error("Failed to verify field. Try again.", "Error");
      }
    );
  }

  getBrandDetailsTable() {
    const payload = {
      brandName: this.BrandName,
      ndaNumber: this.NDAnumber,
      dosage: this.saveOldData?.['Dosage forms'] || this.saveOldData?.['dosage_forms']
    };

    this.isBrandDetailsLoading = true;

    this.compitiveService.getBrandDetailsTableData(
      payload.brandName,
      payload.ndaNumber,
      payload.dosage
    ).subscribe((res: any) => {
      this.isBrandDetailsLoading = false;
      this.brandDetailsTableData = res || [];
      this.isForeignCurrency = res?.[0]?.currency !== 'United States Dollar' || res?.[0]?.currency === 'USD';
      this.currencyTypeText = res?.[0]?.currencyTypeText;
    });
  }

  isNumeric(val: any): boolean {
    return !isNaN(val) && val !== null && val !== '';
  }

  formatDecimal(val: number) {
    return Number(val).toFixed(5);
  }

  getConvertedValue(tableData: any[], rowIndex: number, colIndex: number) {
    const row = tableData[rowIndex];

    const keyMap = {
      0: 'q1_Converted',
      1: 'q2_Converted',
      2: 'halfYearTotal_Converted',
      3: 'q3_Converted',
      4: 'q4_Converted',
      5: 'fullYearTotal_Converted'
    };

    return row?.[keyMap[colIndex]] ?? '';
  }
}
